import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOperations = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/GetOperations`
  );
  return data;
};
export const getEvents = async () => {
  const { data } = await axios.get(`${api_base_url}/Configuration/GetEvents`);
  return data;
};
export const getEmailWorkFlow = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/EmailWorkFlow`
  );
  return data;
};
export const getFilteredOperation = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/FilteredOperation`
  );
  return data;
};
// Insert New EmailRecipient
export const addEmailWorkFlow = async (newEmailWorkFlow) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/EmailWorkFlow`,
    {
      ...newEmailWorkFlow[0],
    }
  );
  return data;
};
// Update EmailWorkflow
export const updateEmailWorkFlow = async (emailWorkflowUdpatedData) => {
  await axios.put(
    `${api_base_url}/Configuration/EmailWorkFlow`,
    ...emailWorkflowUdpatedData
  );
};

export const deleteEmailWorkflow = async (events) => {
  await axios.delete(`${api_base_url}/Configuration/EmailWorkflow`, {
    data: events,
  });
};
